import { useEffect, useState } from "react";
import { getPublicJobs } from "../../../../services/jobService";
import { getDateOnly } from "../../../../utils/dateUtils";
import EmptyState from "../../../../Components/EmptyState/EmptyState";
import JobCard from "../JobCard/JobCard";
import FreelancerViewCompanyModal from "../../../../Components/FreelancerViewCompanyModal/FreelancerViewCompanyModal";
import { Filter, X, ChevronDown } from "lucide-react";
import "./OpenJobs.scss";

// ─── CATEGORIAS DISPONÍVEIS ──────────────────────────────
const CATEGORIES = [
    { id: "abertura-fechamento-evento", label: "Abertura/Fechamento de evento", icon: "🎪" },
    { id: "acessor-eventos", label: "Acessor (a) de eventos", icon: "📋" },
    { id: "administrador-eventos", label: "Administrador (a) de eventos", icon: "💼" },
    { id: "agente-receptivo", label: "Agente de receptivo", icon: "🧳" },
    { id: "ajudante-carga-descarga", label: "Ajudante de carga e descarga", icon: "📦" },
    { id: "ajudante-cozinha", label: "Ajudante de cozinha", icon: "🍳" },
    { id: "animador", label: "Animador (a)", icon: "🎉" },
    { id: "apresentador", label: "Apresentador (a)", icon: "🎤" },
    { id: "artista-circense", label: "Artista circense", icon: "🎪" },
    { id: "assistente-artista", label: "Assistente de artista", icon: "🎭" },
    { id: "assistente-camarim", label: "Assistente de camarim", icon: "👗" },
    { id: "assistente-decoracao", label: "Assistente de decoração", icon: "🌸" },
    { id: "assistente-eventos", label: "Assistente de eventos", icon: "📋" },
    { id: "assistente-palco", label: "Assistente de palco", icon: "🎭" },
    { id: "assistente-producao", label: "Assistente de produção", icon: "🎬" },
    { id: "assistente-producao-artistica", label: "Assistente de produção artística", icon: "🎨" },
    { id: "assistente-producao-eventos", label: "Assistente de produção de eventos", icon: "🎪" },
    { id: "assistente-som", label: "Assistente de som", icon: "🎧" },

    { id: "auxiliar-bar", label: "Auxiliar de Bar", icon: "🍸" },
    { id: "auxiliar-bilheteria", label: "Auxiliar de bilheteria", icon: "🎟️" },
    { id: "auxiliar-buffet", label: "Auxiliar de buffet", icon: "🍽️" },
    { id: "auxiliar-buffet-casamento", label: "Auxiliar de buffet de casamento", icon: "💍" },
    { id: "auxiliar-credenciamento", label: "Auxiliar de credenciamento", icon: "🪪" },
    { id: "auxiliar-desmontagem", label: "Auxiliar de desmontagem", icon: "🔧" },
    { id: "auxiliar-estoque", label: "Auxiliar de estoque", icon: "📦" },
    { id: "auxiliar-eventos", label: "Auxiliar de eventos", icon: "🎪" },
    { id: "auxiliar-governanca", label: "Auxiliar de governança", icon: "🏨" },
    { id: "auxiliar-lavanderia", label: "Auxiliar de lavanderia", icon: "🧺" },
    { id: "auxiliar-limpeza", label: "Auxiliar de Limpeza", icon: "🧹" },
    { id: "auxiliar-logistica", label: "Auxiliar de logística", icon: "🚚" },
    { id: "auxiliar-manutencao", label: "Auxiliar de manutenção", icon: "🔧" },
    { id: "auxiliar-montagem", label: "Auxiliar de montagem", icon: "🛠️" },
    { id: "auxiliar-palco", label: "Auxiliar de palco", icon: "🎭" },
    { id: "auxiliar-recepcao", label: "Auxiliar de recepção", icon: "👋" },
    { id: "auxiliar-servicos-gerais", label: "Auxiliar de serviços gerais", icon: "🧹" },
    { id: "auxiliar-sushiman", label: "Auxiliar de sushiman", icon: "🍣" },
    { id: "auxiliar-producao", label: "Auxiliar de produção", icon: "🏭" },
    { id: "auxiliar-producao-artistica", label: "Auxiliar de produção artística", icon: "🎨" },

    { id: "bailarino", label: "Bailarino (a)", icon: "💃" },
    { id: "banda-grupo-musical", label: "Banda / Grupo musical", icon: "🎸" },
    { id: "barback", label: "Barback", icon: "🍺" },
    { id: "barman", label: "Barman", icon: "🥃" },
    { id: "bartender", label: "Bartender", icon: "🍹" },
    { id: "bartender-eventos", label: "Bartender de eventos", icon: "🍸" },
    { id: "bilheteiro", label: "Bilheteiro (a)", icon: "🎟️" },
    { id: "bombeiro-civil", label: "Bombeiro (a) civil", icon: "🚒" },
    { id: "brigadista", label: "Brigadista", icon: "🧯" },

    { id: "cabeleireiro", label: "Cabeleireiro (a)", icon: "💇" },
    { id: "caixa", label: "Caixa", icon: "💰" },
    { id: "cantor", label: "Cantor (a)", icon: "🎤" },
    { id: "carregador", label: "Carregador (a)", icon: "📦" },
    { id: "cenografo", label: "Cenógrafo (a)", icon: "🎨" },
    { id: "cenotecnico", label: "Cenotécnico (a)", icon: "🛠️" },
    { id: "chef", label: "Chef", icon: "👨‍🍳" },
    { id: "chef-cozinha", label: "Chef de cozinha", icon: "👨‍🍳" },
    { id: "chapeiro", label: "Chapeiro (a)", icon: "🍔" },
    { id: "cinegrafista", label: "Cinegrafista", icon: "🎥" },
    { id: "coletor-residuos", label: "Coletor (a) de resíduos", icon: "♻️" },
    { id: "concierge", label: "Concierge", icon: "🛎️" },
    { id: "confeiteiro", label: "Confeiteiro (a)", icon: "🧁" },
    { id: "conferente", label: "Conferente", icon: "📋" },
    { id: "controlador-acesso", label: "Controlador (a) de acesso", icon: "🚪" },
    { id: "coordenador-eventos", label: "Coordenador (a) de eventos", icon: "📅" },
    { id: "coordenador-producao", label: "Coordenador (a) de produção", icon: "📋" },
    { id: "coreografo", label: "Coreógrafo (a)", icon: "💃" },
    { id: "criador-conteudo", label: "Criador (a) de conteúdo", icon: "📱" },
    { id: "cumim", label: "Cumim", icon: "🍽️" },

    { id: "decorador", label: "Decorador (a)", icon: "🌸" },
    { id: "decorador-eventos", label: "Decorador (a) de eventos", icon: "🎊" },
    { id: "demonstrador-produtos", label: "Demonstrador (a) de produtos", icon: "🛍️" },
    { id: "designer-sobrancelhas", label: "Designer de sobrancelhas", icon: "✨" },
    { id: "dj", label: "DJ", icon: "🎧" },
    { id: "dj-auxiliar", label: "DJ auxiliar", icon: "🎛️" },
    { id: "dj-casamento", label: "DJ de casamento", icon: "💍" },
    { id: "dancarino", label: "Dançarino (a)", icon: "💃" },

    { id: "editor-foto", label: "Editor (a) de foto", icon: "📸" },
    { id: "editor-video", label: "Editor (a) de vídeo", icon: "🎬" },
    { id: "embaixador-marca", label: "Embaixador (a) de marca", icon: "⭐" },
    { id: "enfermeiro-eventos", label: "Enfermeiro (a) para eventos", icon: "🩺" },
    { id: "entregador", label: "Entregador (a)", icon: "🛵" },
    { id: "expedidor-pedidos", label: "Expedidor (a) de pedidos", icon: "📦" },

    { id: "faxineiro", label: "Faxineiro (a)", icon: "🧹" },
    { id: "filmmaker", label: "Filmmaker", icon: "🎥" },
    { id: "filmmaker-casamento", label: "Filmmaker de casamento", icon: "💍" },
    { id: "fiscal-evento", label: "Fiscal de evento", icon: "📋" },
    { id: "fiscal-salao", label: "Fiscal de salão", icon: "👀" },
    { id: "florista", label: "Florista", icon: "🌷" },
    { id: "fotografo", label: "Fotógrafo (a)", icon: "📷" },
    { id: "fotografo-casamento", label: "Fotógrafo (a) de casamento", icon: "💍" },
    { id: "fotografo-eventos", label: "Fotógrafo (a) de eventos", icon: "📸" },

    { id: "garcom", label: "Garçom (a)", icon: "🍽️" },
    { id: "garcom-banquete", label: "Garçom (a) de banquete", icon: "🍽️" },
    { id: "garcom-casamento", label: "Garçom (a) de casamento", icon: "💍" },
    { id: "gerente", label: "Gerente", icon: "👔" },
    { id: "gerente-restaurante", label: "Gerente de restaurante", icon: "🍽️" },
    { id: "gerente-eventos", label: "Gerente de eventos", icon: "🎪" },
    { id: "guia-turismo", label: "Guia de turismo", icon: "🗺️" },
    { id: "guia-turismo-bilingue", label: "Guia de turismo bilíngue", icon: "🌎" },
    { id: "governanta", label: "Governanta", icon: "🏨" },

    { id: "host-hostess", label: "Host / Hostess", icon: "👋" },
    { id: "host-eventos", label: "Host de eventos", icon: "🎪" },
    { id: "hostess", label: "Hostess", icon: "👩‍💼" },
    { id: "hostess-eventos", label: "Hostess de eventos", icon: "🎟️" },

    { id: "influencer", label: "Influencer", icon: "📱" },
    { id: "instrumentista", label: "Instrumentista", icon: "🎸" },
    { id: "interprete", label: "Intérprete", icon: "🗣️" },

    { id: "lavador-loucas", label: "Lavador (a) de louças", icon: "🍽️" },
    { id: "lavador-roupas", label: "Lavador (a) de roupas", icon: "🧺" },
    { id: "lider-salao", label: "Líder de salão", icon: "👔" },

    { id: "maquiador", label: "Maquiador (a)", icon: "💄" },
    { id: "maquiador-artistico", label: "Maquiador (a) artístico", icon: "🎨" },
    { id: "manicure", label: "Manicure", icon: "💅" },
    { id: "manobrista", label: "Manobrista", icon: "🚗" },
    { id: "magico", label: "Mágico (a)", icon: "🎩" },
    { id: "mensageiro", label: "Mensageiro (a)", icon: "📨" },
    { id: "medico-eventos", label: "Médico (a) para eventos", icon: "🩺" },
    { id: "mestre-cerimonias", label: "Mestre de cerimônias", icon: "🎤" },
    { id: "modelo", label: "Modelo", icon: "👤" },
    { id: "modelo-feminina", label: "Modelo Feminina", icon: "👩" },
    { id: "modelo-masculino", label: "Modelo Masculino", icon: "👨" },
    { id: "modelo-passarela", label: "Modelo de passarela", icon: "👠" },
    { id: "modelo-promocional", label: "Modelo promocional", icon: "⭐" },
    { id: "montador-estruturas", label: "Montador (a) de estruturas", icon: "🛠️" },
    { id: "montador-palco", label: "Montador (a) de palco", icon: "🎭" },
    { id: "musico", label: "Músico (a)", icon: "🎵" },
    { id: "musico-casamento", label: "Músico (a) de casamento", icon: "💍" },
    { id: "motorista", label: "Motorista", icon: "🚗" },
    { id: "motorista-artistas", label: "Motorista de artistas", icon: "🚙" },
    { id: "motorista-transporte-equipe", label: "Motorista de transporte de equipe", icon: "🚐" },
    { id: "motorista-van", label: "Motorista de van", icon: "🚐" },
    { id: "motorista-particular", label: "Motorista particular", icon: "🚗" },
    { id: "motoboy", label: "Motoboy / Motogirl", icon: "🏍️" },

    { id: "nail-designer", label: "Nail designer", icon: "💅" },

    { id: "operador-audio", label: "Operador (a) de áudio", icon: "🎧" },
    { id: "operador-camera", label: "Operador (a) de câmera", icon: "📹" },
    { id: "operador-iluminacao", label: "Operador (a) de iluminação", icon: "💡" },
    { id: "operador-pdv", label: "Operador (a) de PDV", icon: "💳" },
    { id: "operador-video", label: "Operador (a) de vídeo", icon: "🎥" },
    { id: "operador-caixa", label: "Operador (a) de caixa", icon: "💰" },
    { id: "operador-bilheteria", label: "Operador (a) de bilheteria", icon: "🎟️" },
    { id: "organizador-eventos", label: "Organizador (a) de eventos", icon: "📅" },
    { id: "orientador-publico", label: "Orientador (a) de público", icon: "👥" },

    { id: "orador", label: "Orador (a)", icon: "🎙️" },
    { id: "palhaco", label: "Palhaço (a)", icon: "🤡" },
    { id: "pedicure", label: "Pedicure", icon: "💅" },
    { id: "performer", label: "Performer", icon: "🎭" },
    { id: "pizzaiolo", label: "Pizzaiolo (a)", icon: "🍕" },
    { id: "piscineiro", label: "Piscineiro (a)", icon: "🏊" },

    { id: "produtor-artistico", label: "Produtor (a) artístico (a)", icon: "🎨" },
    { id: "produtor-eventos", label: "Produtor (a) de eventos", icon: "🎪" },
    { id: "produtor-palco", label: "Produtor (a) de palco", icon: "🎭" },
    { id: "produtor-executivo", label: "Produtor (a) executivo (a)", icon: "💼" },
    { id: "produtor-conteudo", label: "Produtor (a) de conteúdo", icon: "📱" },
    { id: "promotor", label: "Promotor (a)", icon: "📣" },
    { id: "promotor-degustacao", label: "Promotor (a) de degustação", icon: "🍴" },
    { id: "promotor-eventos", label: "Promotor (a) de eventos", icon: "🎪" },
    { id: "promotor-marca", label: "Promotor (a) de marca", icon: "⭐" },
    { id: "promotor-merchandising", label: "Promotor (a) de merchandising", icon: "🛍️" },
    { id: "promotor-vendas", label: "Promotor (a) de vendas", icon: "💰" },

    { id: "recepcionista", label: "Recepcionista", icon: "👋" },
    { id: "recepcionista-bilingue", label: "Recepcionista bilíngue", icon: "🌎" },
    { id: "recepcionista-eventos", label: "Recepcionista de eventos", icon: "🎪" },
    { id: "recepcionista-hotel", label: "Recepcionista de hotel", icon: "🏨" },
    { id: "recepcionista-stand", label: "Recepcionista de stand", icon: "🎟️" },
    { id: "recepcionista-promocional", label: "Recepcionista promocional", icon: "⭐" },
    { id: "recreador", label: "Recreador (a)", icon: "🎉" },
    { id: "recreador-hotel", label: "Recreador (a) de hotel", icon: "🏨" },
    { id: "recreador-piscina", label: "Recreador (a) de piscina", icon: "🏊" },
    { id: "recreador-infantil", label: "Recreador (a) infantil", icon: "🧸" },
    { id: "roadie", label: "Roadie", icon: "🎸" },

    { id: "salgadeiro", label: "Salgadeiro (a)", icon: "🥟" },
    { id: "salva-vidas", label: "Salva-vidas", icon: "🛟" },
    { id: "seguranca", label: "Segurança", icon: "🛡️" },
    { id: "seguranca-backstage", label: "Segurança de backstage", icon: "🛡️" },
    { id: "seguranca-camarim", label: "Segurança de camarim", icon: "🛡️" },
    { id: "seguranca-patrimonial", label: "Segurança patrimonial", icon: "🛡️" },
    { id: "social-media", label: "Social Media", icon: "📱" },
    { id: "socorrista", label: "Socorrista", icon: "🚑" },
    { id: "sommelier", label: "Sommelier", icon: "🍷" },
    { id: "sous-chef", label: "Sous-chef", icon: "🔪" },
    { id: "sushiman", label: "Sushiman", icon: "🍣" },
    { id: "stagehand-auxiliar-palco", label: "Stagehand / Auxiliar de palco", icon: "🎭" },
    { id: "supervisor-salao", label: "Supervisor (a) de salão", icon: "👔" },

    { id: "tecnico-enfermagem-eventos", label: "Técnico (a) de enfermagem para eventos", icon: "🩺" },
    { id: "tecnico-iluminacao", label: "Técnico (a) de iluminação", icon: "💡" },
    { id: "tecnico-palco", label: "Técnico (a) de palco", icon: "🎭" },
    { id: "tecnico-som", label: "Técnico (a) de som", icon: "🔊" },
    { id: "tecnico-video", label: "Técnico (a) de vídeo", icon: "🎥" },
    { id: "transfer-transporte-turistico", label: "Transfer / Transporte turístico", icon: "🚌" },

    { id: "vendedor", label: "Vendedor (a)", icon: "🛍️" },
    { id: "videomaker", label: "Videomaker", icon: "🎥" },

    { id: "wedding-planner", label: "Wedding planner", icon: "💍" },

    { id: "outros", label: "Outros", icon: "📌" },
];

const CATEGORY_MAP = Object.fromEntries(
    CATEGORIES.map(({ id, label }) => [id, label])
);

export default function OpenJobs({ onViewFinished }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [viewingCompanyId, setViewingCompanyId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPublicJobs();
        // console.log("📦 Vagas recebidas:", data);
        setJobs(data);
      } catch {
        setError("Erro ao carregar vagas. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const today = getDateOnly(new Date());
  const endOfWeek = new Date();
  endOfWeek.setDate(endOfWeek.getDate() + 7);
  const endOfWeekStr = getDateOnly(endOfWeek);

  // ─── FILTRO POR DATA ──────────────────────────────────────
  const getDateFilteredJobs = (jobsList) => {
    return jobsList.filter((j) => {
      const jobDate = getDateOnly(j.date);
      if (filter === "urgent") return j.isUrgent;
      if (filter === "today") return jobDate === today;
      if (filter === "week") return jobDate >= today && jobDate <= endOfWeekStr;
      return true;
    });
  };

  // ─── FILTRO POR CATEGORIA (baseado no title) ─────────────
  const getCategoryFilteredJobs = (jobsList) => {
    // Se não tem categorias selecionadas, retorna tudo
    if (selectedCategories.length === 0) return jobsList;

    // Converte os IDs selecionados para os labels correspondentes
    const selectedLabels = selectedCategories.map(
      (id) => CATEGORY_MAP[id] || id
    );

    console.log("🎯 Categorias selecionadas:", selectedLabels);

    return jobsList.filter((job) => {
      // 🔥 O título da vaga é a categoria
      const jobTitle = job.title || "";

      console.log(`🔍 Vaga: "${jobTitle}" vs Categorias:`, selectedLabels);

      // Verifica se o título da vaga corresponde a alguma categoria selecionada
      return selectedLabels.some((selectedLabel) => {
        // Comparação case insensitive
        return jobTitle.toLowerCase().trim() === selectedLabel.toLowerCase().trim();
      });
    });
  };

  // ─── APLICA TODOS OS FILTROS ────────────────────────────
  const getFilteredJobs = () => {
    const dateFiltered = getDateFilteredJobs(jobs);
    const categoryFiltered = getCategoryFilteredJobs(dateFiltered);
    return categoryFiltered;
  };

  const filteredJobs = getFilteredJobs();

  // ─── CONTAGEM DE VAGAS POR CATEGORIA ────────────────────
  const getCategoryCount = (categoryId) => {
    const categoryLabel = CATEGORY_MAP[categoryId] || categoryId;
    return jobs.filter((job) => {
      const jobTitle = job.title || "";
      return jobTitle.toLowerCase().trim() === categoryLabel.toLowerCase().trim();
    }).length;
  };

  // ─── TOGGLE CATEGORIA ────────────────────────────────────
  const toggleCategory = (categoryId) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  // ─── LIMPAR FILTROS ──────────────────────────────────────
  const clearFilters = () => {
    setSelectedCategories([]);
    setFilter("all");
  };

  const filters = [
    { key: "all", label: "Todas" },
    { key: "urgent", label: "⚡ Urgentes" },
    { key: "today", label: "Hoje" },
    { key: "week", label: "Esta semana" },
  ];

  // ─── FECHAR DROPDOWN AO CLICAR FORA ─────────────────────
  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdown = document.querySelector(".open-jobs__category-dropdown");
      if (dropdown && !dropdown.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ─── RENDER ──────────────────────────────────────────────
  if (loading) {
    return (
      <div className="open-jobs__centered">
        <p className="open-jobs__loading">Carregando vagas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="open-jobs__centered">
        <p className="open-jobs__error">{error}</p>
      </div>
    );
  }

  if (jobs.length === 0) {
    return <EmptyState message="Todas as vagas foram preenchidas! Aguarde por novas oportunidades." />;
  }

  return (
    <div className="open-jobs">
      {/* ─── BARRA DE FILTROS ──────────────────────────────── */}
      <div className="open-jobs__filters-bar">
        <div className="open-jobs__quick-filters">
          {filters.map((f) => (
            <button
              key={f.key}
              className={`open-jobs__chip ${filter === f.key ? "open-jobs__chip--active" : ""}`}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Dropdown de categorias */}
        <div className="open-jobs__category-dropdown">
          <button
            className={`open-jobs__dropdown-btn ${selectedCategories.length > 0 ? "open-jobs__dropdown-btn--has-filter" : ""}`}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <Filter size={16} />
            <span>Categorias</span>
            {selectedCategories.length > 0 && (
              <span className="open-jobs__dropdown-badge">
                {selectedCategories.length}
              </span>
            )}
            <ChevronDown
              size={16}
              className={`open-jobs__dropdown-chevron ${isDropdownOpen ? "open-jobs__dropdown-chevron--open" : ""}`}
            />
          </button>

          {isDropdownOpen && (
            <div className="open-jobs__dropdown-menu">
              <div className="open-jobs__dropdown-header">
                <span className="open-jobs__dropdown-title">Filtrar por categoria</span>
                {selectedCategories.length > 0 && (
                  <button
                    className="open-jobs__dropdown-clear"
                    onClick={() => setSelectedCategories([])}
                  >
                    <X size={14} />
                    Limpar
                  </button>
                )}
              </div>

              <div className="open-jobs__dropdown-list">
                {CATEGORIES.map((category) => {
                  const isSelected = selectedCategories.includes(category.id);
                  const count = getCategoryCount(category.id);

                  return (
                    <label
                      key={category.id}
                      className={`open-jobs__dropdown-item ${isSelected ? "open-jobs__dropdown-item--selected" : ""}`}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleCategory(category.id)}
                        className="open-jobs__dropdown-checkbox"
                      />
                      <span className="open-jobs__dropdown-icon">{category.icon}</span>
                      <span className="open-jobs__dropdown-label">{category.label}</span>
                      <span className="open-jobs__dropdown-count">{count}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ─── TAGS DE CATEGORIAS SELECIONADAS ────────────── */}
      {selectedCategories.length > 0 && (
        <div className="open-jobs__selected-tags">
          <span className="open-jobs__tags-label">Filtros ativos:</span>
          {selectedCategories.map((id) => {
            const category = CATEGORIES.find(c => c.id === id);
            return (
              <span key={id} className="open-jobs__tag">
                {category?.icon} {category?.label}
                <button
                  className="open-jobs__tag-remove"
                  onClick={() => toggleCategory(id)}
                >
                  <X size={12} />
                </button>
              </span>
            );
          })}
          <button className="open-jobs__clear-all" onClick={clearFilters}>
            Limpar todos
          </button>
        </div>
      )}

      {/* ─── RESULTADOS ────────────────────────────────────── */}
      {filteredJobs.length === 0 ? (
        <EmptyState message="Nenhuma vaga encontrada para esse filtro." />
      ) : (
        <>
          <div className="open-jobs__results-count">
            {filteredJobs.length} vaga{filteredJobs.length > 1 ? "s" : ""} encontrada{filteredJobs.length > 1 ? "s" : ""}
          </div>

          <div className="open-jobs__grid">
            {filteredJobs.map((job) => (
              <JobCard
                key={job.id}
                job={job}
                applicationStatus={job.applicationStatus}
                onViewFinished={onViewFinished}
                onViewCompany={() => setViewingCompanyId(job.companyId)}
              />
            ))}
          </div>
        </>
      )}

      {/* ─── MODAL ──────────────────────────────────────────── */}
      {viewingCompanyId && (
        <FreelancerViewCompanyModal
          companyId={viewingCompanyId}
          onClose={() => setViewingCompanyId(null)}
        />
      )}
    </div>
  );
}